import CONFIG from "@bd-core/config";

const Store_Variable = {
  data: [],

  set(argData) {
    this.data = argData;
  },

  resolveBlock(block) {
    if (!block) return block;

    try {
      const blockStr = JSON.stringify(block);
      let blockReplaced = blockStr;

      for (let variable of this.data) {
        const varName = "{{" + variable.name + "}}";
        blockReplaced = blockReplaced.replace(
          new RegExp(varName, "g"),
          variable.value
        );
      }

      blockReplaced = blockReplaced.replace(
        new RegExp("{{player_name}}", "g"),
        CONFIG.user.nickname
      );

      block = JSON.parse(blockReplaced);
    } catch (e) {
      // console.log("e", e);
    }

    return block;
  },

  getAudioFromVariable(data) {
    return this.getMediaFromVariable("audio", data);
  },

  getVideoFromVariable(data) {
    return this.getMediaFromVariable("video", data);
  },

  getMediaFromVariable(type, data) {
    if (
      !data.variable.use_variable ||
      data.variable.from_variable_type !== type
    )
      return null;

    const varName = data.variable.from_variable_name;
    const varValue = this.data.find((v) => v.name === varName);
    if (!varValue || !varValue.value) return;

    return varValue.value;
  },
};

export default Store_Variable;
